import controller from './chapter-dues-profile.controller.js';

let chapterDuesProfileModule = angular.module('chapter-dues-profile', [])

    .directive('chapterDuesProfile', () => {
        'ngInject';

        return {
            retrict: 'EA',
            controller: controller,
            controllerAs: '$ctrl',
            scope: {},
            bindToController: true,
            transclude: true,
            link: (scope, element, attrs, ctrlr, transclude) => {
                transclude(scope, (clone, scope) => {
                    element.append(clone);
                });
            }
        };
    })

    .name;

export default chapterDuesProfileModule;



// WEBPACK FOOTER //
// ./src/app/angular/chapter-dues-profile/chapter-dues-profile.js